import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const TopItemsLoader: LoaderFnConfig = {
    id: 'top-items-widget',
    loaderFn: () => import('./top-items-widget.feature'),
    product: ClientConfigProductName.SPORTS,
};
